/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { BaseEnum } from '../../shared/enums/base/BaseEnum';

export class SignatureType extends BaseEnum {
  static ALPHABETICAL = new SignatureType('ALPHABETICAL');

  static FACSIMILE = new SignatureType('FACSIMILE');
}
